var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CSpinner',{staticClass:"loading",attrs:{"color":"info"}}),_c('br'),_c('div',{staticClass:"text-center"},[_c('CButton',{attrs:{"color":"secondary","size":"sm"},on:{"click":_vm.reloadPage}},[_vm._v(" Refresh ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }